import './Testimonials.css';
import clientsUnderline from '../../assets/figma_clients_underline.svg';
import checkDecagram from '../../assets/figma_check_decagram.svg';

const reviews = [
  {
    name: 'Jennifer W.',
    date: 'April 2026',
    text: 'The installation was very professional and efficient, and was completed in one day. We have had our panels for over 8 months now and had no issues. My Sales rep Mary could not have been more helpful and really knew the product from start to finish. We are getting credits on our summer bills and winter bills have been drastically reduced.',
  },
  {
    name: 'Paul M.',
    date: 'May 2026',
    text: 'Watt & Wattle have done a great job installing solar panels for me at a great price. The team was terrific and I continue to recommend them to friends and family.',
  },
  {
    name: 'Savio and Malika',
    date: 'May 2026',
    text: 'Great company, fantastic service. All staff involved were 100% committed to providing excellent service. Would highly recommend. I received a friendly call from our team to make sure I was happy with the service. Fantastic company, wonderful staff.',
  },
  {
    name: 'Thierry',
    date: 'May 2026',
    text: 'Very happy with cost, installation and performance of the panels and inverter. The installers were professional. I am glad I decided to go ahead with Watt & Wattle. Thanks for your customer service.',
  },
];

function Stars() {
  return (
    <div className="review-stars" aria-label="5 stars">
      {[...Array(5)].map((_, i) => (
        <svg key={i} width="22" height="22" viewBox="0 0 20 20" fill="#FFC107" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.49L10 14.27l-4.94 2.59.94-5.5L2 7.31l5.53-.8L10 1.5z" />
        </svg>
      ))}
      <img src={checkDecagram} alt="Verified" className="review-verified" />
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="testimonials">
      <div className="testimonials-inner">
        <h2 className="testimonials-title">
          What our{' '}
          <span className="testimonials-highlight">
            clients say
            <img src={clientsUnderline} alt="" className="testimonials-underline" aria-hidden="true" />
          </span>
        </h2>
        <p className="testimonials-subtitle">
          Real feedback from homeowners across Melbourne.
        </p>

        <div className="testimonials-grid">
          {reviews.map((r, i) => (
            <div key={i} className="review-card">
              <h4 className="review-name">{r.name}</h4>
              <span className="review-date">{r.date}</span>
              <Stars />
              <p className="review-text">{r.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
